import { fetchRespondents } from "./respondant-actions-creators";
import axios from "axios";
import { API_END_POINT } from "../../../../config";
import { startSpinner, stopSpinner } from "../../../shared-components/custom-spinner/custom-spinner-store/spinner-actions";
import { loadToaster } from "../../../shared-components/toaster/toaster-actions-creators";
import { fetchCurrentSurveyName, fetchProjectCode } from "../../ProjectList/home-store/home-actions-creators";
// home-actions-creators.js
export const fetchRespondentsData = (surveyId, startDate, endDate, orderBy = 'Response_id', startRow = 1, endRow = 10) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
       const { data } = await axios.get(
        `${API_END_POINT.BASE_URL}/api/Response/GetResponse_View/${surveyId}/${startDate}/${endDate}/${orderBy}/${startRow}/${endRow}`
      );
      dispatch(fetchRespondents(data));
      // console.log("Fetched Respondents Data:", data);
    if (data?.data?.length > 0) {
  
  dispatch(fetchProjectCode(data?.Survey_Code));
  dispatch(fetchCurrentSurveyName(data?.Survey_Name));
}

      dispatch(stopSpinner());
      return data; // Return the fetched data for further processing if needed
    } catch (err) {
      dispatch(stopSpinner());
      dispatch(loadToaster({ type: 'error', title: 'Failed to fetch respondents', msg: err.message }));
    }
  };
};

export const downloadResponses = (surveyId, startDate, endDate) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await axios.get(
        `${API_END_POINT.BASE_URL}/api/Response/GetResponse_Download/${surveyId}/${startDate}/${endDate}`,
        { responseType: 'blob' }
      );
      // Trigger browser download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `responses_${surveyId}.xlsx`);
      document.body.appendChild(link);
      link.click();
      dispatch(stopSpinner());
    } catch (err) {
      dispatch(stopSpinner());
      dispatch(loadToaster({ type: 'error', title: 'Download failed', msg: err.message }));
    }
  };
};